import { css } from '@emotion/css';

export const groupHeader = css({
  display: 'block',
});
